import { render, staticRenderFns } from "./MainLayout.vue?vue&type=template&id=5a6a1827&"
import script from "./MainLayout.vue?vue&type=script&lang=js&"
export * from "./MainLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/projects/releases/338/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a6a1827')) {
      api.createRecord('5a6a1827', component.options)
    } else {
      api.reload('5a6a1827', component.options)
    }
    module.hot.accept("./MainLayout.vue?vue&type=template&id=5a6a1827&", function () {
      api.rerender('5a6a1827', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/layouts/MainLayout.vue"
export default component.exports